// extracted by mini-css-extract-plugin
export default {"p":"about_p__QuqHR","img":"about_img__9u24w"};